import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ErrorBoundary } from 'components/common';
import { useSelector, useDispatch } from 'react-redux';
import http from 'api/http';

import { RootState } from 'reducers/root';
import AppLayout from './app.layout';
import { refreshProfile } from '../reducers/auth';

const PrivateRoute = (): JSX.Element => {
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);
  const loginState = useSelector((state: RootState) => state.auth.loginState);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (accessToken) {
      http.configureRequest({ accessToken });
      dispatch(refreshProfile());
    }
  }, [accessToken]);

  if (!accessToken) return <Redirect to="/login" />;

  if (loginState !== 'DONE') return <Redirect to="/wh-selector" />;

  return (
    <ErrorBoundary>
      <Switch>
        <Route path="/" component={AppLayout} />
      </Switch>
    </ErrorBoundary>
  );
};

export default PrivateRoute;
